import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-pin",
  "use": "svg_i-pin-usage",
  "viewBox": "0 0 10 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 13\" id=\"svg_i-pin\"><path d=\"M5.583 8.187 5 7.77l-.583.418L1 10.638V1h8v9.638l-3.417-2.45Z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol